import { createFileRoute } from "@tanstack/react-router";
import { PaginaRota } from "@/paginas/vendaManual";

export const Route = createFileRoute("/_authenticated/vendaManual")({
  head: () => ({
    meta: [
      { title: "Registrar vendas — Milky Moo Palmares" },
      {
        name: "description",
        content: "Informe a quantidade vendida de cada produto e o sistema baixa os insumos.",
      },
      { property: "og:title", content: "Registrar vendas — Milky Moo Palmares" },
      {
        property: "og:description",
        content: "Informe a quantidade vendida de cada produto e o sistema baixa os insumos.",
      },
    ],
  }),
  component: PaginaRota,
});
